import * as Types from '../../../../graphql.d';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions =  {}
export type GetProductPagesSlugQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetProductPagesSlugQuery = { __typename?: 'query_root', b2CSmartphoneCatalog?: Types.Maybe<{ __typename?: 'B2CSmartphoneCatalogEntityResponse', data?: Types.Maybe<{ __typename?: 'B2CSmartphoneCatalogEntity', attributes?: Types.Maybe<{ __typename?: 'B2CSmartphoneCatalog', catalogId: string, entries?: Types.Maybe<Array<Types.Maybe<{ __typename?: 'ComponentEntriesSmartphoneEntry', subscriptions?: Types.Maybe<{ __typename?: 'SmartphoneSubscriptionRelationResponseCollection', data: Array<{ __typename?: 'SmartphoneSubscriptionEntity', attributes?: Types.Maybe<{ __typename?: 'SmartphoneSubscription', smartphoneVariant?: Types.Maybe<{ __typename?: 'SmartphoneVariantEntityResponse', data?: Types.Maybe<{ __typename?: 'SmartphoneVariantEntity', attributes?: Types.Maybe<{ __typename?: 'SmartphoneVariant', slug: string, smartphoneFamily?: Types.Maybe<{ __typename?: 'SmartphoneFamilyEntityResponse', data?: Types.Maybe<{ __typename?: 'SmartphoneFamilyEntity', attributes?: Types.Maybe<{ __typename?: 'SmartphoneFamily', slug: string }> }> }> }> }> }> }> }> }> }>>> }> }> }> };


export const GetProductPagesSlugDocument = gql`
    query getProductPagesSlug {
  b2CSmartphoneCatalog {
    data {
      attributes {
        catalogId
        entries {
          subscriptions {
            data {
              attributes {
                smartphoneVariant {
                  data {
                    attributes {
                      slug
                      smartphoneFamily {
                        data {
                          attributes {
                            slug
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;
export function useGetProductPagesSlugQuery(baseOptions?: Apollo.QueryHookOptions<GetProductPagesSlugQuery, GetProductPagesSlugQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductPagesSlugQuery, GetProductPagesSlugQueryVariables>(GetProductPagesSlugDocument, options);
      }
export function useGetProductPagesSlugLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductPagesSlugQuery, GetProductPagesSlugQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductPagesSlugQuery, GetProductPagesSlugQueryVariables>(GetProductPagesSlugDocument, options);
        }
export type GetProductPagesSlugQueryHookResult = ReturnType<typeof useGetProductPagesSlugQuery>;
export type GetProductPagesSlugLazyQueryHookResult = ReturnType<typeof useGetProductPagesSlugLazyQuery>;
export type GetProductPagesSlugQueryResult = Apollo.QueryResult<GetProductPagesSlugQuery, GetProductPagesSlugQueryVariables>;